// removed by extract-text-webpack-plugin
module.exports = {"pagechildren":"_1wB-XtMPlrJHFab4IxaKBX","childa":"_2CBbn1gpawo8lfnLyxlBTX","status":"_2VJjtB8V_zImFcbMYoLrSK","evaluate":"_1wOKg90RR9hTLaXqvWicVv","childb":"BlgqLEFg3riGB6pSeHOE4","pagelienew":"_3-Zduvz6bfAwfrGmWCTMKs","lienewtop":"XkKKpcnL9Y6bPvdjxiFza","newtoptxt":"_3JG4ZnhOmneUW1c_zsabm3"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ServiceOrderListComponent/ServiceOrderListComponent.scss
 ** module id = 1032
 ** module chunks = 0
 **/